import axios from 'axios'

export default {
    namespaced: true,
    state: {
        transactions: []
    },
    mutations: {
        GET_TRANSACTIONS(state, payload){
            state.transactions = payload
        },
    },
    actions: {
        transactions({ commit, getters }) {
            return new Promise((resolve, reject) => {
                axios.get('transaction')
                .then(res => {
                    commit('GET_TRANSACTIONS', res.data.data)
                    resolve(res.data.data)
                })
                .catch(error => {
                    reject(error.response)
                })
            })
        },
        validationRow({ commit, getters }) {
            return new Promise((resolve, reject) => {
                axios.get('transaction/row/validation')
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(error => {
                    reject(error.response)
                })
            })
        },
        show({ commit, getters }, _id) {
            return new Promise((resolve, reject) => {
                axios.get(`transaction/${_id}`)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(error => {
                    reject(error.response)
                })
            })
        },
        store({ commit, getters }, {formData}) {
            return new Promise((resolve, reject) => {
                axios.post('transaction', formData)
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        showTransactionsByUserClientId({ commit, getters }, {entityId,entityType,currencyId}) {
            return new Promise((resolve, reject) => {
                axios.get(`transaction/findForIdUserClient/${entityId}/${entityType}/${currencyId}`)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
    }
}